import { render, staticRenderFns } from "./giftListPopup.vue?vue&type=template&id=11f39f4c&"
import script from "./giftListPopup.vue?vue&type=script&lang=ts&"
export * from "./giftListPopup.vue?vue&type=script&lang=ts&"
import style0 from "./giftListPopup.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports